export default function AccordionMain($DOM, classes) {
	const $container = $('.accordion-main');

	if(!$container.length) {
		return false;
	}

	$container.find('.accordion__head').click(function() {
		$(this).parent().toggleClass(classes.Active).siblings().removeClass(classes.Active);
	});
}